import { fromJS } from 'immutable';

import handleDefault from '../handleDefault';

const ENTITY_IDENTIFIER = 'basicSchemaItems';
const initialState = fromJS({
  entities: {},
});

export default function reducer(instate = initialState, action) {
  switch (action.type) {
    default:
      return handleDefault(ENTITY_IDENTIFIER)(instate, action);
  }
}
